function generateGrid(width, height, size) {
  const grid = [
    // [0, 250],
    // [0, 500],
  ];

  // Iterate over the rows
  for (let y = 0; y < height; y += size) {
    // Iterate over the columns
    for (let x = size; x < width; x += size) {
      grid.push([x - size, y - size]);
    }
  }

  return grid;
}
// function generateGrid(width, height, size) {
//   const grid = [];
//   for (let y = 0; y < height + size; y += size) {
//     for (let x = 0; x < width; x += size) {
//       grid.push([window.innerWidth > 1024 ? x : x - size, window.innerWidth > 1024 ? y : y - size * 2]);
//     }
//   }
//   return grid;
// }

export const generateWatermarks = ({ email, mobileNumber, elementId, blockSize = 200, opacity = 0.2 }) => {
  // find element by id question-container
  const questionContainer = document.getElementById(elementId);
  // find height and width of question-container
  const height = questionContainer.offsetHeight;
  const width = questionContainer.offsetWidth;
  // set size of watermark to height/2 if height is less than 500 else 250
  const size = blockSize;

  const grid = generateGrid(width, height, size);
  // remove all the watermarks
  const watermarks = document.getElementsByClassName("watermark" + elementId);
  while (watermarks.length > 0) {
    watermarks[0].parentNode.removeChild(watermarks[0]);
  }
  grid.forEach((point) => {
    const watermarkEl = document.createElement("div");
    watermarkEl.classList.add("watermark" + elementId);
    watermarkEl.style.left = `${point[0]}px`;
    watermarkEl.style.top = `${point[1] + size}px`;
    watermarkEl.style.width = `${size}px`;
    watermarkEl.style.height = `200px`;
    watermarkEl.style.backgroundImage = `url("data: image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='300px' width='300px'><text transform='translate(20, 250) rotate(-45)' fill='rgba(148, 163, 184, ${opacity})' font-size='20'>${email}</text></svg>")`;
    watermarkEl.style.backgroundRepeat = "no-repeat";
    watermarkEl.style.backgroundPosition = "center";
    watermarkEl.style.backgroundSize = "contain";
    watermarkEl.style.position = "absolute";
    watermarkEl.style.zIndex = "999";
    watermarkEl.style.pointerEvents = "none";
    questionContainer.appendChild(watermarkEl);

    const watermarkMobileEl = document.createElement("div");
    watermarkMobileEl.classList.add("watermark" + elementId);
    watermarkMobileEl.style.left = `${point[0] + 10}px`;
    watermarkMobileEl.style.top = `${point[1] + size + 10}px`;
    watermarkMobileEl.style.width = `${size}px`;
    watermarkMobileEl.style.height = `210px`;
    watermarkMobileEl.style.backgroundImage = `url("data: image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='300px' width='300px'><text transform='translate(20, 250) rotate(-45)' fill='rgba(148, 163, 184, ${opacity})' font-size='20'>${mobileNumber}</text></svg>")`;
    watermarkMobileEl.style.backgroundRepeat = "no-repeat";
    watermarkMobileEl.style.backgroundPosition = "center";
    watermarkMobileEl.style.backgroundSize = "contain";
    watermarkMobileEl.style.position = "absolute";
    watermarkMobileEl.style.zIndex = "999";
    watermarkMobileEl.style.pointerEvents = "none";
    questionContainer.appendChild(watermarkMobileEl);
  });
};
